import { MIME } from '@shared/utils/download';

export const openPdfDoc = (base64String: string) => {
  const byteCharacters = atob(base64String);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  // Исправлен некорректный MIME 'application/pdf; base64' (такого типа не существует) → application/pdf:
  // WebKit на неизвестном MIME не открывает PDF во вкладке
  const blob = new Blob(byteArrays, { type: MIME.PDF });

  const dataUrl = URL.createObjectURL(blob);

  window.open(dataUrl, '_blank');
};
